/**
 * Types for the brand assets management feature.
 * Assets are logos and avatars uploaded per client, categorized
 * as "round" (profile pics, favicons) or "freestyle" (logos).
 */

export interface ClientAsset {
  id: number;
  clientId: string;
  fileId: string;
  category: AssetCategory;
  tags: string[];
  originalFilename: string;
  mimeType: string;
  fileSize: number;
  width: number | null;
  height: number | null;
  createdAt: string | null;
  updatedAt: string | null;
  thumbnailUrl: string | null;
}

export type AssetCategory = "round" | "freestyle";

export const AVAILABLE_TAGS = [
  "dark",
  "white",
  "color",
  "primary",
  "secondary",
  "monochrome",
] as const;

export type AssetTag = (typeof AVAILABLE_TAGS)[number];

/**
 * Target dimensions for round asset resizing.
 * Keys are descriptive names, values are [width, height] tuples.
 */
export const ROUND_SIZE_TARGETS: Record<string, [number, number]> = {
  favicon_16: [16, 16],
  favicon_32: [32, 32],
  favicon_64: [64, 64],
  apple_touch: [180, 180],
  fb_profile: [170, 170],
  ig_profile: [320, 320],
  twitter_profile: [400, 400],
  youtube_profile: [800, 800],
  linkedin_profile: [400, 400],
  og_square: [512, 512],
};

/** Minimum pixel dimension for a round asset to support size generation */
export const MIN_ROUND_SIZE = 800;

/** API response shape for fetching client assets */
export interface ClientAssetsResponse {
  round: ClientAsset[];
  freestyle: ClientAsset[];
}
